import Button from 'components/Button';
import { ArrowRightIcon } from 'components/icons';
import styled from 'styled-components';
import { from } from 'styles/mixins';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

// Groups the sub-blocks so the section heading keeps its 1rem (16px) distance
// from the content while the blocks themselves stay spaced apart.
export const Blocks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.75rem;
`;

export const SubBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

// Keeps a title and its description tight (no gap between them); the block gap
// still separates the pair from the list below.
export const SubHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubTitle = styled.h3`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.125rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  line-height: 1.3;
`;

export const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  font-size: 1rem;
  line-height: 1.5;
`;

export const ConversationList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0 0.75rem;
  display: flex;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.colors.grey200};
  border-radius: 8px;
`;

export const ConversationRow = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey200};

  &:last-child {
    border-bottom: 0;
  }

  &::before {
    content: '•';
    color: ${({ theme }) => theme.colors.accent};
    line-height: 1.3;
  }
`;

export const ConversationTitle = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.accent};
  font-size: 0.875rem;
  font-weight: ${({ theme }) => theme.weights.bold};
  line-height: 1.3;

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const FeedbackList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;

  ${from.mobileXL`
    grid-template-columns: 1fr 1fr;
  `}
`;

export const FeedbackCard = styled.li`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  border: 1px solid ${({ theme }) => theme.colors.grey200};
  border-radius: 4px;
  padding: 0.75rem;
`;

export const FeedbackThumbnail = styled.div<{ $src: string }>`
  width: 100%;
  padding-top: 56.25%;
  margin-bottom: 0.25rem;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.greyBlue};
  background-image: ${({ $src }) => `url(${$src})`};
  background-size: cover;
  background-position: center;
`;

export const FeedbackTitle = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black};
  font-size: 1rem;
  line-height: 1.5;

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const FeedbackMeta = styled.span`
  color: ${({ theme }) => theme.colors.black};
  font-size: 0.875rem;
  line-height: 1.3;
`;

export const Footer = styled.div`
  display: flex;
`;

export const ViewMoreButton = styled(Button)`
  && {
    align-self: flex-start;
    align-items: center;
    width: fit-content;
    gap: 0.25rem;
    padding: 0.5rem 0.75rem;
  }
`;

export const ButtonArrow = styled(ArrowRightIcon)`
  width: 1.25rem;
  height: 1.25rem;
`;
